<template>
  <div class="wealthManagement">
    
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.wealthManagement {
  
}
</style>